var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "aboutModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.about"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c("div", { staticClass: "mx-auto" }, [
                _vm._v(
                  "\n      Copyright © OWASP Foundation. All Rights Reserved.\n    "
                ),
              ]),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("img", {
              attrs: {
                src: require("@/assets/img/brand/dt-logo-white-text.svg"),
                width: "200",
              },
            }),
          ]),
          _c("b-col", { attrs: { align: "right" } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/brand/owasp-logo-white.svg"),
                width: "120",
              },
            }),
          ]),
        ],
        1
      ),
      _c("hr"),
      _c("p", [
        _vm._v(
          "\n    OWASP Dependency-Track is an intelligent Component Analysis platform that\n    allows organizations to identify and reduce risk in the software supply\n    chain.\n  "
        ),
      ]),
      _c(
        "b-row",
        [
          _c("b-col", [
            _vm._v(
              "\n      " +
                _vm._s(this.dtrack.application) +
                " v" +
                _vm._s(this.dtrack.version)
            ),
            _c("br"),
            _vm._v("\n      Build ID: " + _vm._s(this.dtrack.uuid)),
            _c("br"),
            _vm._v(
              "\n      Built On: " + _vm._s(_vm.serverTimestamp) + "\n    "
            ),
          ]),
          _c("b-col", [
            _vm._v("\n      Frontend v" + _vm._s(this.$version.version)),
            _c("br"),
            _vm._v("\n      Build ID: " + _vm._s(this.$version.uuid)),
            _c("br"),
            _vm._v(
              "\n      Built On: " + _vm._s(_vm.frontendTimestamp) + "\n    "
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c("b-col", [
            _vm._v(
              "\n      Database Product: " +
                _vm._s(this.dtrack.database.productName)
            ),
            _c("br"),
            _vm._v(
              "\n      Database Version: " +
                _vm._s(this.dtrack.database.productVersion) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _c("hr"),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h6", [_vm._v("Community Resources")]),
            _c("ul", { staticClass: "fa-ul" }, [
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("a", { attrs: { href: "https://dependencytrack.org/" } }, [
                  _vm._v("Website"),
                ]),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-book",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "a",
                  { attrs: { href: "https://docs.dependencytrack.org/" } },
                  [_vm._v("Documentation")]
                ),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-github",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "a",
                  { attrs: { href: "https://github.com/DependencyTrack" } },
                  [_vm._v("GitHub")]
                ),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-slack",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "a",
                  { attrs: { href: "https://dependencytrack.org/slack" } },
                  [_vm._v("Slack")]
                ),
                _vm._v(" ("),
                _c(
                  "a",
                  {
                    attrs: { href: "https://dependencytrack.org/slack/invite" },
                  },
                  [_vm._v("invite")]
                ),
                _vm._v(")\n        "),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://bsky.app/profile/dependencytrack.bsky.social",
                    },
                  },
                  [_vm._v("Bluesky")]
                ),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://infosec.exchange/@DependencyTrack",
                    },
                  },
                  [_vm._v("Mastodon")]
                ),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-youtube-play",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.youtube.com/c/OWASPDependencyTrack",
                    },
                  },
                  [_vm._v("YouTube")]
                ),
              ]),
            ]),
          ]),
          _c("b-col", [
            _c("h6", [_vm._v("Datasource Providers")]),
            _c("ul", { staticClass: "fa-ul" }, [
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("a", { attrs: { href: "https://nvd.nist.gov/" } }, [
                  _vm._v("National Vulnerability Database"),
                ]),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("a", { attrs: { href: "https://ossindex.sonatype.org/" } }, [
                  _vm._v("Sonatype OSS Index"),
                ]),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("a", { attrs: { href: "https://github.com/advisories" } }, [
                  _vm._v("GitHub Advisories"),
                ]),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("a", { attrs: { href: "https://snyk.io/" } }, [
                  _vm._v("Snyk"),
                ]),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("a", { attrs: { href: "https://osv.dev/" } }, [
                  _vm._v("OSV"),
                ]),
              ]),
              _c("li", [
                _c("i", {
                  staticClass: "fa-li fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "a",
                  { attrs: { href: "https://vulndb.cyberriskanalytics.com" } },
                  [_vm._v("VulnDB")]
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }